module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAAHlBMVEUAAAAAlfgAlPgAlPkAkvkAlPkAlPkAk/gAk/gAk/i3Z04UAAAACXRSTlMAJCZPenqF/f73MmIEAAAAU0lEQVQoz2NggAFGAQZM4NGKKcZUOV0BQ5B55kyDUUGcgsrGYGA2c2YyhGXEwMBaORMNTHdgkJiJARqxC7Jg047VotHoIEUQa/Jm8GjBkjuQsgwAmldgs8S4lV0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/添加.png
// module id = 2Twc
// module chunks = 1